/* eslint-disable check-file/filename-blocklist -- pre-existing .jsx; this change only swaps colour values for dark mode, converting to .tsx is a separate migration */
import { Flex, Spinner } from '@chakra-ui/react';

export const Loader = () => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      position="absolute"
      width="full"
      height="full"
      bg="var(--kula-dark-scrim, rgba(246, 247, 247, 0.9))"
      top="0"
      left="0"
      zIndex={2}
      borderBottomStartRadius="16px"
      borderBottomEndRadius="16px"
    >
      <Spinner top="50%" color="light.highlight" />
    </Flex>
  );
};
